import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '首页 - 链大宗商品平台',
    component: () => import('../views/Cover/Cover.vue'),
  },
  {
    path: '/Index',
    name: 'Index',
    component: () => import('../views/Index/Index.vue'),
    children: [
      {
        path: '',
        name: '我的 - 链大宗商品平台',
        component: () => import('../views/Index/Mine/Mine.vue'),
      },
      {
        path: 'aboutUs',
        name: '关于我们 - 链大宗商品平台',
        component: () => import('../views/Index/AboutUs/AboutUs.vue'),
      },
      {
        path: 'searching',
        name: '商城 - 链大宗商品平台',
        component: () => import('../views/Index/Searching/Searching.vue'),
      },
      {
        path: 'bid',
        name: '竞价 - 链大宗商品平台',
        component: () => import('../views/Index/Bid/Bid.vue'),
      },
      {
        path: 'bidDetail/:data',
        name: '竞价详情 - 链大宗商品平台',
        component: () => import('../views/Index/BidDetail/BidDetail.vue'),
      },
      {
        path: 'monitor',
        name: '监管仓 - 链大宗商品平台',
        component: () => import('../views/Index/Monitor/Monitor.vue'),
      },
      {
        path: 'detail/:data',
        name: '商品详情 - 链大宗商品平台',
        component: () => import('../views/Index/Detail/Detail.vue'),
      },
      {
        path: 'profile',
        name: '个人资料 - 链大宗商品平台',
        component: () => import('../views/Index/Profile/Profile.vue'),
      },
      {
        path: 'orderBill',
        name: '我的订单 - 链大宗商品平台',
        component: () => import('../views/Index/OrderBill/OrderBill.vue'),
      },
      {
        path: 'mark',
        name: '我的关注 - 链大宗商品平台',
        component: () => import('../views/Index/Mark/Mark.vue'),
      },
      {
        path: 'myProduct',
        name: '我的在售 - 链大宗商品平台',
        component: () => import('../views/Index/MyProduct/MyProduct.vue'),
      },
      {
        path: 'myOrder',
        name: '求购记录 - 链大宗商品平台',
        component: () => import('../views/Index/MyOrder/MyOrder.vue'),
      },
      {
        path: 'transport',
        name: '物流 - 链大宗商品平台',
        component: () => import('../views/Index/Transport/Transport.vue'),
      },
      {
        path: 'data',
        name: 'AI数据 - 链大宗商品平台',
        component: () => import('../views/Index/Data/Data.vue'),
      },
      {
        path: 'notFound',
        name: '走丢了 - 链大宗商品平台',
        component: () => import('../views/Index/NotFound/NotFound.vue'),
      },
    ]
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(((to, from, next) => {
  document.title = to.name ? to.name : '';
  next();
}));

export default router
